// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"601":"3ee491b2","733":"8f854cbc","765":"cd28c85d"}[chunkId] + ".chunk.js";
};